export enum ExaminationState {
  Draft = "draft",
  Pending = "pending",
  Completed = "completed",
  Billed = "billed",
}
